/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{isFloat32Array as r,isFloat64Array as t}from"../../../typedArrayUtil.js";function n(t){return r(t)&&t.length>=3}function e(r){return(t(r)||Array.isArray(r))&&r.length>=3}function i(r){return n(r)||e(r)}export{i as isVec3};
